import Layout from "../Layouts/Index";
import React, {useState} from "react";
import CallToAction from "../Views/CallToAction";
import BenefitSection from "../Views/BenefitSection";
import HowItWorks from "../Views/HowItWorks";
import AppProcess from "../Views/AppProcess";
import HeroForPassengers from "../Views/HeroForPassengers";

const Passengers = () => {
    const [showAppType, setShowAppType] = useState(false)

    return (
        <Layout>
            <HeroForPassengers />
            <AppProcess
                appType={showAppType}
                setAppType={setShowAppType}
            />
            <HowItWorks
                appType={showAppType}
                setAppType={setShowAppType}
            />
            <CallToAction />
            <BenefitSection />
        </Layout>
    )
}

export default Passengers